import { createAction, props } from '@ngrx/store';

export const ProjectCodeSnippetInitializedAction = createAction(
  '[Project Code Snippet] Initialized',
);

export const WidgetSnippetVersionsRequestErroredAction = createAction(
  '[Widget Snippet Effects] Versions Request Errored',
);

export const WidgetSnippetVersionsLoadedAction = createAction(
  '[Widget Snippet Effects] Versions Loaded',
  props<{ versions: string[] }>(),
);
